import React from 'react';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, INK, Reveal, Title } from '../components/deck/Type';
const channels = [{
  tone: INK.emerald,
  name: 'Enterprise sales',
  items: ['Venture funds', 'Corporate venture teams', 'Family offices', 'Strategic institutional contracts']
}, {
  tone: INK.violet,
  name: 'Ecosystem distribution',
  items: ['Accelerators', 'Angel networks', 'Venture programs and conferences', 'Innovation hubs and Raiseboards']
}, {
  tone: INK.blue,
  name: 'Strategic partnerships',
  items: ['Data providers', 'Enterprise platforms', 'Government and economic development', 'Research institutions and regional partners']
}];
export function GoToMarketSlide() {
  return <Slide index={13} data-id="element-150" data-mp="b6zzdtajl0bu">
      <div className="flex items-start justify-between gap-[3vw]" data-id="element-151" data-mp="77r3oivxysdn">
        <div className="max-w-[62%]" data-id="element-152" data-mp="75ed5hc4b9oz">
          <Eyebrow data-id="element-153" data-mp="106r5cizy3xk5">Go to market</Eyebrow>
          <Title className="mt-[2.2vh]" data-id="element-154" data-mp="107tualdpjpxf">
            Enterprise proof opens the door; ecosystem distribution expands the
            network.
          </Title>
        </div>
        <Caption className="max-w-[26%] text-right" data-id="element-155" data-mp="196nwqsdpzaiw">
          Three connected channels feeding one intelligence layer.
        </Caption>
      </div>

      <div className="mt-auto grid grid-cols-3 gap-[2.4vw]" data-id="element-156" data-mp="1e3xo4dko5w9d">
        {channels.map((channel, i) => <Reveal key={channel.name} delay={0.08 * i} className="flex h-full flex-col" data-id="element-157" data-mp="1j3ahzi9yk3lg" data-mpi={i}>
            <div className="h-px w-full" style={{
          background: channel.tone
        }} data-id="element-158" data-mp="1n4m072qi5mjm" />
            <h3 className="mt-[2.2vh] text-[clamp(16px,1.85vw,38px)] leading-tight text-[#F4F7FC]" style={{
          fontFamily: 'var(--font-serif)'
        }} data-id="element-159" data-mp="1rxym353srf8o">
              {channel.name}
            </h3>
            <ul className="mt-[2vh] space-y-[1.2vh]" data-id="element-160" data-mp="21trxgl5s52ov">
              {channel.items.map(item => <li key={item} className="text-[clamp(10px,1.08vw,23px)] leading-snug text-[#C3CBD9]" data-id="element-161" data-mp="26sbnoxrep0n1">
                  {item}
                </li>)}
            </ul>
          </Reveal>)}
      </div>

      <Reveal delay={0.36} className="mt-[3.4vh] flex items-center justify-between border-t border-white/12 pt-[2.2vh]" data-id="element-162" data-mp="1qxodwwmlbv5u">
        <p className="text-[clamp(11px,1.18vw,25px)] text-[#C3CBD9]" data-id="element-163" data-mp="1zwih55uffjsd">
          One institutional customer or program brings its companies, partners
          and ecosystem relationships into the platform with it.
        </p>
        <span className="text-[clamp(8px,0.82vw,17px)] uppercase tracking-[0.22em] text-[#2FBE8F]" data-id="element-164" data-mp="29u6d1z3rqxc4">
          Coverage compounds per account
        </span>
      </Reveal>
    </Slide>;
}